import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  AGENT_BANNER_CREATE,
  AGENT_BANNER_LIST,
  AGENT_BANNER_UPDATE,
  AGENT_BANNER_DELETE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'agentbanner' })
export default class AgentBanner extends VuexModule {
  list: any = [];

  @Mutation
  mutateAgentBanner(agentbanner) {
    this.list = agentbanner;
  }

  @Action({ commit: 'mutateAgentBanner' })
  FetchAgentBanner(params = {}) {
    return Vue.axios({
      url: BASE_URL + AGENT_BANNER_LIST,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  CreateAgentBanner(params) {
    return Vue.axios({
      url: BASE_URL + AGENT_BANNER_CREATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  UpdateAgentBanner(params) {
    return Vue.axios({
      url: BASE_URL + AGENT_BANNER_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  DeleteAgentBanner(params) {
    return Vue.axios({
      url: BASE_URL + AGENT_BANNER_DELETE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
